import { Block } from 'components/Block'
import { GuidebookStep, stepMemorializeData } from 'components/content/guidebook/content'
import { GuidebookStepHeader } from 'components/content/guidebook/guidebookStepHeader/GuidebookStepHeader'
import {
  highlightedParagraphCss,
  SButton,
  SCaption,
  SGridWrapper,
} from './GuidebookStepMemorialize.styled'
import { HighlightedParagraph } from 'components/highlightedParagraph/HighlightedParagraph'
import { Picture } from 'components/picture/Picture'
import { useTranslation } from 'next-i18next'
import Router from 'next/router'
import { useAuth } from 'utils/auth/hooks/useAuth'
import { numberRange } from 'utils/general'

export function GuidebookStepMemorialize(props: { step: GuidebookStep }) {
  const { isLogged } = useAuth()
  const { t } = useTranslation('eol_guide')

  return (
    <>
      <GuidebookStepHeader
        step={props.step}
        description={t('eol_guide.step_3.description')}
        image={<Picture imageKey={'illustrations/memorialize'} sizes={'700px'} />}
      />
      <Block>
        <div>
          <SCaption>{t('eol_guide.step_3.cards_caption')}</SCaption>
          <SGridWrapper>
            {numberRange(6).map((i) => (
              <HighlightedParagraph
                key={i}
                iconProps={{ size: '2rem' }}
                wrapperCss={highlightedParagraphCss}
                hideAction
                {...stepMemorializeData[i]}
              />
            ))}
          </SGridWrapper>
          <SButton
            type="button"
            size="large"
            onClick={() => {
              Router.push(isLogged ? '/me/dashboard' : '/signup')
            }}
          >
            {t('eol_guide.step_3.cta')}
          </SButton>
        </div>
      </Block>
    </>
  )
}
